import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASBonusPickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DeadwoodGameMode} from "../gamemode/DeadwoodGameMode";
import {Deadwood} from "../Deadwood";
import {DeadwoodSoundConfig} from "../DeadwoodSoundConfig";
import {BelowStakeWinRestriction} from "./BelowStakeWinRestriction";

export class DeadwoodPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName : "Deadwood",
            hasActionSpin : true,
            bonusGame : {
                header : () => "FREESPINS",
                options : [ // pick index: 1-FREESPIN_GUNSLINGER, 2-FREESPIN_HUNTERS.
                    {name : "Hunter Spins", id : 2, image : "hunter.png"},
                    {name : "Gunslinger Spins", id : 1, image : "gunslinger.png"}
                ],
                type : ASBonusPickOptions.PICK_MODE,
                pickNeededForModes : [DeadwoodGameMode.FREESPIN_PICK],
                pickNeededForBuyFeatures : [
                    "FREESPIN",
                    "FREESPIN_BOUNTY"
                ]
            },
            graphics : {backgroundTextureName : ""},
            getParsedData : (response:any, bet:number, prevResponse:any):ASWinData => {
                const parsedData:ASWinData = {
                    totalWin : response.accumulatedRoundWin,
                    wasFeatureBuy : response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin : this.isFreeSpinTriggered(response),
                    totalSpinWinnings : this.getWin(response, bet, prevResponse),
                    isBigWin : this.isBigWin(response),
                    winType : WINTYPE.NORMAL,
                    featureName : this.getFeatureName(response),
                    isRoundComplete : this.isRoundComplete(response),
                    isBonusEnd : this.isBonusEnd(response),
                    isWinCapHit : response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any):boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio:number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if(response.wasFeatureBuy) {
            const betPrice:number = BelowStakeWinRestriction.getBuyFeaturePrice(response.playedBetValue);
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }


    private getWin(response:any, bet:number, prevData:any):number {
        return response.totalSpinWinnings;
    }

    private isFreeSpinTriggered(response:any):boolean {
        return response.nextMode === DeadwoodGameMode.FREESPIN_PICK;
    }

    private getFeatureName(response:any):string {

        const shootOut = response.fsSuperModeActive ? "SHOOT OUT " : "";

        if((response.mode == DeadwoodGameMode.FREESPIN_PICK && response.nextMode == DeadwoodGameMode.FREESPIN_GUNSLINGER) || response.mode == DeadwoodGameMode.FREESPIN_GUNSLINGER) {
            return shootOut + "GUNSLINGER SPINS";
        }
        if((response.mode == DeadwoodGameMode.FREESPIN_PICK && response.nextMode == DeadwoodGameMode.FREESPIN_HUNTERS) || response.mode == DeadwoodGameMode.FREESPIN_HUNTERS) {
            return shootOut + "HUNTER SPINS";
        }

        if(response.nextMode == DeadwoodGameMode.FREESPIN_PICK) {
            if(response.fsSuperModeActive) {
                return "SHOOT OUT FREESPINS"
            }

            return Deadwood.api.translations.translate("Pick Bonus Mode");
        }

        return response.nextMode;
    }

    private isRoundComplete(response:any):boolean {
        return true;// ([DeadCanaryGameMode.FREESPIN, DeadCanaryGameMode.FREESPIN_SUPER, DeadCanaryGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:any):boolean {
        return ((response.nextMode === DeadwoodGameMode.NORMAL) && (response.mode === DeadwoodGameMode.FREESPIN_HUNTERS || response.mode === DeadwoodGameMode.FREESPIN_GUNSLINGER));
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if(trigger == ActionSpinSound.WIN) {
            SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.AS_WIN);
        } else if(trigger == ActionSpinSound.BIG_WIN) {
            SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.AS_WIN_BIG);
        }
    }


}